import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagFiltrosAvanzadosFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagFiltrosAvanzados'>
      {({ field }) => (
        <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagFiltrosAvanzados' label='Filtros avanzados' />
      )}
    </Field>
  )
}

export default React.memo(FlagFiltrosAvanzadosFormGroup)
